export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN'

export const SET_PROFILE_AUTH = 'SET_PROFILE_AUTH'

export const RESTE_ALL_AUTH_DATA = 'RESTE_ALL_AUTH_DATA'

export const SET_AUTH_LOADING = 'SET_AUTH_LOADING'